"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandlerMapping = void 0;
var defaultHandler_1 = require("./defaultHandler");
var emailHandler_1 = require("./emailHandler");
var ipAddressHandler_1 = require("./ipAddressHandler");
var stringHandler_1 = require("./stringHandler");
var HandlerMapping = /** @class */ (function () {
    function HandlerMapping() {
    }
    HandlerMapping.getNames = function () {
        return Object.keys(HandlerMapping.handlersMapping);
    };
    HandlerMapping.getByName = function (name) {
        return HandlerMapping.handlersMapping[name || 'default'] || HandlerMapping.handlersMapping.default;
    };
    HandlerMapping.handlersMapping = {
        default: defaultHandler_1.defaultHandler,
        email: emailHandler_1.emailHandler,
        ipAddress: ipAddressHandler_1.ipAddressHandler,
        string: stringHandler_1.stringHandler,
    };
    return HandlerMapping;
}());
exports.HandlerMapping = HandlerMapping;
//# sourceMappingURL=HandlerMapping.js.map